import React from 'react';
import { Menu } from 'lucide-react';
import RFQDashboard from '@/js/screens/Supplier/RFQDashboard';
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from '@/components/ui/drawer';
import { Button } from '@/components/ui/button';
import LeftSidebar from '@/js/components/sidebars/LeftSidebar';
import SidebarSheetWrapper from '@/js/components/sidebars/SidebarSheetWrapper';
import RightSideBar from '@/js/components/sidebars/RightSidebar';

const RFQConfirmationPage = ({ data }) => {
  return (
    <div className="flex min-h-[calc(100vh-70px)] w-full overflow-hidden">
      {/* Mobile Sidebar (Drawer) */}
      <div className="lg:hidden p-4">
        <Drawer>
          <DrawerTrigger asChild>
            <Menu size={28} className="cursor-pointer mt-7 ml-5" />
          </DrawerTrigger>
          <DrawerContent>
            <div className="mx-auto w-full max-w-sm">
              <DrawerHeader>
                <DrawerTitle>Menu</DrawerTitle>
              </DrawerHeader>
              <LeftSidebar role="supplier" />
              <DrawerClose asChild>
                <Button variant="outline" className="w-full">
                  Close
                </Button>
              </DrawerClose>
            </div>
          </DrawerContent>
        </Drawer>
      </div>

      {/* Desktop Sidebar (Left) */}
      <div className="hidden lg:flex w-[5%] flex-shrink-0 shadow-md">
        <div className="side-menu w-full h-full pt-5">
          <SidebarSheetWrapper role="supplier" />
        </div>
      </div>

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col px-10 overflow-hidden">
        <h1 className="text-4xl py-4 font-bold">
          Congratulations! Your Quote has been Shared! 🎉
        </h1>
        <div className="py-4 test-sm">
          Manufacturers will review your request and respond withinthe given
          deadline.
        </div>
        <div className="bg-gray-50 p-2 mt-6 font-semibold w-2/3">
          Quote Number: Q12345
        </div>
        <div className="font-semibold bg-gray-50 p-2 mt-10 w-2/3">
          Response Deadline: 10 March 2025{' '}
        </div>
        <div className="font-semibold py-10">
          You will recieve updates as Ronald Industry responds
        </div>
      </div>
    </div>
  );
};

export default RFQConfirmationPage;
